import React from 'react';

function About() {
  return (
    <div className='about'>
      <h1>About rEMOTION</h1>
      <p>
      2020 was an extraodinary time for people with everyone sharing several
      global experiences and movements. rEMOTION is an international response from
      some incredible Asian artists to the hard times that modern times brings,
      a counter to isolation and apathy. 

      While focusing on Asian diaspora, voices, and representation, we welcome
      all voices to be a part of the project and audience.
      </p>
    </div>
  )
}

export default About;
